<template>
<div>
    <navsearch placeholder="搜索收件人或收件号码" @onsearch="onsearch"></navsearch>
    <van-tabs v-model="tabCurrentIndex" @change="tabchange">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
            <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
              <div class="nnlist">

                <van-list v-model="navitem.loaded" :finished="navitem.loadingType=='nomore'?true:false" :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'" @load="loadData">

                    <div v-for="(item,index) in navitem.orderList" :key="index">
                        <div class="order-item" @click="godetail(item)">
                            <div class="order-item-sl">
                                <div class="item-header">
                                    <span class="item-header-left">订单:{{item.tid}}</span>
                                    <span class="item-header-right right-tit">{{item.deliveryStatus==1?'部分发货':item.orderStatusEnumName}}</span>
                                </div>
                                <div class="item-list">
                                    <div v-for="(product,i) in item.tradeDetails" :key="i">
                                         <div class="comcard" @click="goto(product)">
                                            <div class="comcardinfo">
                                                <div class="comimg">
                                                    <img :src="$baseurl+product.productImageUrl">
                                                </div>
                                                <div class="comproduct">
                                                    <div class="com-header">
                                                        <div class="com-header-left van-multi-ellipsis--l2">{{product.productName}}</div>
                                                        <div class="com-header-right">￥{{product.price}}</div>
                                                    </div>
                                                    <div class="clearboth"></div>
                                                    <div v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor}">
                                                        【海外产品】
                                                    </div>
                                                    <div class="com-main">
                                                        <span class="com-main-sbg">{{product.specName}}</span>
                                                        <span class="com-right">x{{product.num2}}</span>
                                                    </div>
                                                    <div class="clearboth"></div>
                                                    <div class="com-main cbg" v-if="product.ownNum>0">
                                                        <span class="com-main-sbg">自发数量</span>
                                                        <span class="com-right">x{{product.ownNum}}</span>
                                                    </div>
                                                    <div class="clearboth"></div>
                                                    <div v-if="product.cartonSize" class="com-main">
                                                        <span class="com-main-sbg">箱规:{{product.cartonSize+product.unit+"/箱"}}</span>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-price" v-for="(zitem,zindex) in item.tranferTids" :key="zindex">
                                     <div>
                                        {{zitem.isCompanyOrder?'转公司单号:':'转自发单号:'}}
                                        <span>{{zitem.tid}}</span>
                                    </div>
                                </div>
                                <div class="item-price">
                                    <div>
                                        总价<span class="price-left">￥{{item.payment}}</span>
                                        实付款<span>￥{{item.payment}}</span>
                                    </div>
                                </div>
                                <div class="item-footer">
                                    <div v-if="item.isShowCancel||item.isShowDeal||item.isShowSend||item.isShowPlat">
                                        <!-- <van-button v-if="item.isShowCancel" size="small" color="#ff9970"  plain round type="primary" @click.stop="cancel(item)">取消</van-button> -->
                                        <van-button v-if="item.isShowDeal" size="small" color="#ff9970" plain round type="primary" @click.stop="deal(item)">处理</van-button>
                                        <van-button v-if="item.isShowPay" size="small" color="#ff9970" plain round type="primary" @click.stop="pay(item)">去付款</van-button>
                                        <van-button v-if="item.isShowSend" size="small" color="#ff9970" plain round type="primary" @click.stop="send(item)">发货</van-button>
                                        <van-button v-if="item.isShowPlat" size="small" color="#ff9970" plain round type="primary" @click.stop="logisticinfo(item)">物流轨迹</van-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <van-cell-group class="order-item" @click="godetail(item)">
                            <van-panel :title="'订单：'+item.tid" :status="item.orderStatusEnumName">
                                <div slot="header">
                                    <van-cell class="title" :title="'订单：'+item.tid" :value="item.splitOrderState==1?item.deliveryStatus==1?'部分发货':item.orderStatusEnumName:item.orderStatusEnumName" />
                                </div>
                                <div>
                                    <div>
                                        <div v-for="(product,i) in item.tradeDetails" :key="i">
                                            <trade-card :product='product' />
                                        </div>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="total">总价：￥{{item.payment}}</div>
                                   
                                </div>
                            </van-panel>
                        </van-cell-group> -->

                    </div>

                </van-list>
              </div>
            </van-tab>
        <!-- </van-pull-refresh> -->
    </van-tabs>
    <van-dialog v-model="dialogshow" @confirm="sendorder" @beforeClose="btnclose"    title="请输入快递单号" show-cancel-button>
         <van-field v-model="sendto.logisticName" label="物流方式" placeholder="请输入物流方式" />
            <van-field v-model="sendto.logisticNo" label="快递单号" placeholder="请输入快递单号" />
            
    </van-dialog>

</div>
</template>

<script>
import request from "@/config/ajax";
export default {
    components: {},
    data() {
        return {
            dialogshow:false,
            isLoading: false,
            refreshing: false,
            tabCurrentIndex: 0,
            navList: [{
                    state: 0,
                    text: '全部',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "tranferState":0,
                        "productSku": "",
                        "refundStatus": -1,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 1,
                    text: '待付款',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "productSku": "",
                        "tranferState":4,
                        "sorting": "",
                        "maxResultCount": 10,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 2,
                    text: '待处理',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "tranferState":1,
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "refundStatus": 0,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 3,
                    text: '待发货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "tranferState":2,
                        "productSku": "",
                        "sorting": "",
                        "maxResultCount": 10,
                        "refundStatus": 0,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 4,
                    text: '待收货',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "productSku": "",
                        "tranferState":3,
                        "sorting": "",
                        "maxResultCount": 10,
                        "refundStatus": 0,
                        "skipCount": 0
                    },
                    orderList: []
                },
                {
                    state: 5,
                    text: '退款中',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        "tid": "",
                        "name": "",
                        "sku": "",
                        "nameOrPhone":"",
                        "productSku": "",
                        "tranferState":5,
                        "sorting": "",
                        "maxResultCount": 10,
                        "refundStatus": 1,
                        "skipCount": 0
                    },
                    orderList: []
                }
            ],
            systemsetting: undefined,
            paydto: {
                tid: ''
            },
            sendto:{
                logisticNo:'',
                tid:''
            }
        }
    },
    created() {

        request.post('/api/services/app/SystemSettingFunction/QueryModel').then(x => {
            this.systemsetting = x.result;
        })
        var option = this.$route.query;

        if (option.state) {
            this.tabCurrentIndex = Number.parseInt(option.state);
        }
        this.abp.event.on("app.SendTrade", x => {
            this.$toast.clear();
            if (x.status != 0) {
                this.$toast(x.errMsg);
            } else {
               this.dialogshow=false;
               this.$toast('自发成功!');
               this.navList.forEach(x=>{
                    x.loadingType='refresh';
                })
                this.loadData();
            }
           
        })

        this.loadData();
    },
    methods: {
        tabchange() {
            this.loadData('tabChange');
        },
        onRefresh() {
            this.loadData('refresh');
        },
        logisticinfo(item) {
            //找出公司订单
            var mtid= item.tranferTids.filter(x=>x.isCompanyOrder)[0].tid;
            this.$router.push({
                path: '/logisticstrajectory',
                query: {
                    tid: mtid
                }
            });
        },
        onsearch(val){

            this.navList.forEach(x=>{
                x.getparams.nameOrPhone=val;
                x.loadingType='refresh';
            })
            
           this.loadData();
        },
        loadData(source) {
            //这里是将订单挂载到tab列表下
            let index = this.tabCurrentIndex;
            let navItem = this.navList[index];
            
            // let state = navItem.state;

            if (source === 'tabChange' && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }
            if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
                if (source != "refresh") {
                    return;
                }
            }
            if(navItem.loadingType=='refresh')
            {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            if (source === 'refresh') {
                this.navList[index].orderList = [];
                this.navList[index].getparams.skipCount = 0;
            }
            navItem.loadingType = 'loading';
            var params = navItem.getparams;
            
            //加载数据
            request.post('/api/services/app/PhoneTrade/QueryOrder', params).then(x => {

                this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navList[index].orderList = this.navList[index].orderList.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' : 'nomore';
            }).finally(() => {
                this.navList[index].loaded = false;
                this.refreshing = false;
            });

        },
        godetail(item) {
            // console.log(item);
            this.$router.push({
                path: '/cloundorderdetail',
                query: {
                    tid: item.tid
                }
            });
        },
        btnclose(action, done){
            if (action === 'confirm') {
                done(false);
            } else {
                done();
            }
        },
        pay(item){
            var curtranferorder=item.tranferTids.filter(x=>x.isCompanyOrder);
            if(curtranferorder.length<1)
            {
                Toast('无可付款订单');
                return;
            }
            var tid=curtranferorder[0].tid;
            this.$router.push({
                path: '/pay',
                query: {
                    tid: tid,
                    code:''
                }
            });
        },
        sendorder()
        {
            if(!this.sendto.logisticNo)
            {
                this.$toast('请输入快递单号');
                return;
            }
            if(!this.sendto.logisticName){
                 this.$toast('请输入快递方式');
                return;
            }
            this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '发货中,请稍后',
            });
            
            //需使用推送
            request.post('/api/services/app/PhoneTrade/TranferDeliver', this.sendto).then(x => {
            })
        },
        send(item)
        {
            //先检索 是否有自发订单
            var curtranferorder=item.tranferTids.filter(x=>!x.isCompanyOrder);
            if(curtranferorder.length<1)
            {
                Toast('无可发货订单');
                return;
            }
            
            console.log(item.tranferTids);
            var tid=curtranferorder[0].tid;
            this.sendto.logisticNo='';
            this.sendto.tid=tid;
            this.dialogshow=true;
            //获取当前订单号
        },
        cancel(item)
        {

        },
        deal(item)
        {
            this.$router.push({
                path: '/cloundorderdeal',
                query: {
                    tid: item.tid
                }
            });
        },


    }
}
</script>

<style lang="scss" scoped>

.omheader{
    height: 36px;
    padding: 5px;
    background-color: white;
}
.omheader-info{
    position: relative;
}
.omheader-left{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    text-align: center;
}
.omheader-search{
    height: 36px;
    padding-left: 35px;
    padding-right: 75px;
}
.van-search{
    padding: 0;
    border: 1px solid #ff9369;
    border-radius: 999px;
}
.omheader-search .van-search .van-cell{
    padding: 3px 8px 3px 0;
}

.nnlist{
    position: fixed;
    left: 0;
    right: 0;
    top: 90px;
    bottom: 0;
    overflow: auto;
}

.order-item {
    font-size: 12px;
    margin: 10px 10px 10px 10px;
}

.order-item-sl{
    padding: 10px;
    background-color: white;
    border-radius: 8px;
}
.item-header{
    margin-bottom: 10px;
    min-height: 20px;
    font-size: 14px;
}
.item-header-left{
    float: left;
}
.item-header-right{
    float: right;
}
.right-tit{
    color: #ff4c04;
}
.item-list{
    margin-bottom:10px;
}
.item-price{
    font-size: 12px;
    margin-bottom: 10px;
    text-align: right;
}
.price-left{
    margin-right: 10px;
}

.title {
    border-bottom: 1px solid #e5e5e5;
}

.item-footer{
    text-align: right;
}
.item-footer .van-button{
    padding: 0px 14px 0 14px;
    height: 28px;
    margin-left: 5px;
}


.total {
    font-size: 14px;
    text-align: left;
}

.more {
    overflow-x: scroll;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin: 5px 0 5px 15px;
}

.item {
    width: 90px;
    height: 90px;
    margin-right: 10px;
    display: inline-block;

}

.item img {
    width: 100%;
}

 .comcard{
        background-color: white;
        margin-bottom: 10px;
    }
    .comcardinfo{
        position: relative;
        padding-left:110px;
    }
    .comimg{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0,-50%);
        width: 100px;
        height: 100px;
    }
    .clearboth{
        clear:both;
    }
    .comimg img{
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
    .comproduct{
        min-height: 100px;
        font-size: 12px;
    }
    .com-header{
        padding-right: 66px;
        position: relative;
        font-size: 15px;
        margin-bottom: 5px;
    }
    .com-header-left{
        word-break: break-all;
    }
    .com-header-right{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 14px;
    }
    .com-left{
        float: left;
    }
    .com-right{
        float: right;
    }
    .com-main{
        color:#a7a7a7;
        margin-bottom: 5px;
    }
    .com-main-sbg{
        padding: 2px 6px;
        border-radius: 999px;
        background-color: #eee;
    }


</style>
